import { whenYouTubeReady } from '../utils';

export default (youtubeVideoId) => ({
  open: false,
  player: null,
  playerElement: null,
  youtubeVideoId: '',
  onReady: false,
  onYouTubePlayerAPIReady: false,

  init() {
    this.youtubeVideoId = youtubeVideoId;
    this.playerElement = this.$refs.ytplayer;

    whenYouTubeReady(() => {
      this.onYouTubePlayerAPIReady = true;
    });
  },

  handleClick() {
    if (!this.onYouTubePlayerAPIReady) {
      return;
    }

    if (this.player) {
      this.open = true;
      this.player.playVideo();
      return;
    }

    this.open = true;

    this.player = new YT.Player(this.playerElement, {
      height: 'auto',
      width: '100%',
      videoId: this.youtubeVideoId,
      events: {
        onReady: (event) => {
          const iframe = event.target.getIframe();
          iframe.classList.add('w-full', 'aspect-video');

          this.onReady = true;
          this.player.playVideo();
        }
      }
    });
  }
});